import { BCMSStateManagerCRUD } from "@bcm-dev/bcms-vite";
import LoginPage, { getDefaultPageData, getDefaultPageUI } from "components/pages/LoginPage";
import "./styles.css";

export default function CaptureFastBalancesSetup(props) {
    // initalize a new BCMSStateManagerCRUD instance using the default page data
    const data = BCMSStateManagerCRUD.init(getDefaultPageData())
    .update([ "userID" ], "geo****")
    .update([ "password" ], "")
    .update([ "userIDValOnChange" ], "geo****")
    .update([ "passwordValOnChange" ], "")
    .submit();

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ "showFastBalancesSetupView" ], true)
    .submit();

    return <div className="fast-balance-setup-002"><LoginPage data={ data } ui={ ui } /></div>
}
